const supplier = state => state.supplier
const suppliers = state => state.suppliers

export default {
  supplier,
  suppliers

}
